export default __webpack_public_path__ + "static/media/checkUps.d693755d.png";